<template>
  <v-container fluid dark class="mt-10 mb-12" :style="'overflow-y: scroll; max-height: 100%;'">
    <v-card dark>
      <v-container fluid v-if="!paymentLoading && paymentValid">
        <v-row>
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h6">Numer zamówienia:</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            <span class="text-h4" :style="'color: red;'">{{
              $route.params.orderNumber
            }}</span>
          </v-col>
          <v-col cols="12" class="d-flex justify-center pt-0 pb-0">
            Zapisz ten numer!
          </v-col>
        </v-row>
        <v-divider class="mt-4 mb-4"></v-divider>

        <v-row v-if="paymentLoading">
          <v-col cols="12" class="d-flex justify-center">
            <v-progress-circular indeterminate size="80" color="primary"></v-progress-circular>
          </v-col>
        </v-row>
        <v-row v-else-if="paymentActive && paymentValid && paymentMethod == 'btc'">
          <v-col cols="12" class="d-flex justify-center align-center">
            <span class="text-h6" :style="'color: cyan;'">Oczekiwanie na płatność</span>
            &nbsp;
            <v-img src="../assets/nav1.png" :class="'rotate'"
              :style="'max-height: 50px; max-width: 50px; width: 100%; height: 100%; cursor: pointer;'">
            </v-img>
          </v-col>
          <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0 mt-2 mb-2" v-if="paymentData.plnTotal > 220 &&
            paymentData.plnTotal <= 4000 &&
            exchangeUrl.length == 0
            " @click="goToCC()">
            <v-btn large :loading="ccLoading" light>
              <v-icon>fab fa-cc-visa</v-icon>&nbsp;<v-icon>fab fa-cc-mastercard</v-icon>&nbsp; <strong>Zapłać
                kartą</strong>
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0 mt-2 mb-2" v-if="exchangeUrl.length > 0">
            <v-btn large :loading="ccLoading" light>
              <a :href="exchangeUrl" target="_blank" :style="'color: #1481D1 !important;'"><strong>Do strony
                  płatności</strong>&nbsp;<v-icon>fas fa-arrow-circle-right</v-icon></a>
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0 mt-2 mb-2"
            v-if="paymentData.plnTotal >= 100 && paymentData.plnTotal <= 1000">
            <v-btn large @click="tutorialDialog = true" light>
              <v-icon>fab fa-youtube</v-icon>&nbsp;
              <strong>Jak zapłacić BLIK?</strong>
            </v-btn>
          </v-col>

          <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0">
            Zaksięgowanie wpłaty może zająć do 10 min
          </v-col>
          <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0 mt-2">
            <v-btn class="pl-1 pr-1">
              <a href="/bitcoin" target="_blank" :style="'font-size: 0.8rem;'"><v-icon>fab fa-bitcoin</v-icon>&nbsp; Inne
                sposoby</a>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-progress-linear rounded v-model="timePercentElapsed" color="blue-grey" height="25">
              <template v-slot:default>
                <strong>{{
                  new Date(secondsLeft * 1000).toISOString().substring(14, 19)
                }}</strong>
              </template>
            </v-progress-linear>
          </v-col>

          <v-col cols="12" class="d-flex justify-center" ref="qr">
            <qrcode-vue :value="paymentData.address" :size="200" class="pa-1"
              :style="'background-color: white;'"></qrcode-vue>
          </v-col>
          <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0">
            Ten kod QR możesz zeskanować w bitomacie
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-text-field label="Adres Bitcoin do wpłaty" v-model="paymentData.address" outlined readonly>
              <template v-slot:append>
                <v-btn :style="'transform: translateY(-4px);'" ref="copyAddress"
                  @click="copyToClipboard(paymentData.address)">
                  <v-icon>fas fa-copy</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-text-field label="Ilość Bitcoin do wpłaty" v-model="paymentData.btcTotal" outlined readonly>
              <template v-slot:append>
                <v-btn :style="'transform: translateY(-4px);'" ref="copyTotal"
                  @click="copyToClipboard(paymentData.btcTotal)">
                  <v-icon>fas fa-copy</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-text-field :label="`Ilość ${$store.state.currency}`" v-model="paymentData.plnTotal" outlined readonly>
              <template v-slot:append>
                <v-btn :style="'transform: translateY(-4px);'" ref="copyTotal"
                  @click="copyToClipboard(paymentData.plnTotal)">
                  <v-icon>fas fa-copy</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row v-else-if="paymentActive && paymentValid && paymentMethod == 'eth'">
          <v-col cols="12" class="d-flex justify-center align-center">
            <span class="text-h6" :style="'color: cyan;'">Oczekiwanie na płatność</span>
            &nbsp;
            <v-img src="../assets/nav1.png" :class="'rotate'"
              :style="'max-height: 50px; max-width: 50px; width: 100%; height: 100%; cursor: pointer;'">
            </v-img>
          </v-col>
          <!-- <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0 mt-2 mb-2" v-if="paymentData.plnTotal > 220 &&
              paymentData.plnTotal <= 4000 &&
              exchangeUrl.length == 0
              " @click="goToCC()">
            <v-btn large :loading="ccLoading" light>
              <v-icon>fab fa-cc-visa</v-icon>&nbsp;<v-icon>fab fa-cc-mastercard</v-icon>&nbsp; <strong>Zapłać
                kartą</strong>
            </v-btn>
          </v-col> -->
          <!-- <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0 mt-2 mb-2" v-if="exchangeUrl.length > 0">
            <v-btn large :loading="ccLoading" light>
              <a :href="exchangeUrl" target="_blank" :style="'color: #1481D1 !important;'"><strong>Do strony
                  płatności</strong>&nbsp;<v-icon>fas fa-arrow-circle-right</v-icon></a>
            </v-btn>
          </v-col> -->
          <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0 mt-2 mb-2"
            v-if="paymentData.plnTotal >= 100 && paymentData.plnTotal <= 2000">
            <v-btn large @click="tutorialDialog = true" light>
              <v-icon>fab fa-youtube</v-icon>&nbsp;
              <strong>Jak zapłacić BLIK?</strong>
            </v-btn>
          </v-col>

          <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0">
            Zaksięgowanie wpłaty może zająć do 10 min
          </v-col>
          <!-- <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0 mt-2">
            <v-btn class="pl-1 pr-1">
              <a href="/bitcoin" target="_blank" :style="'font-size: 0.8rem;'"><v-icon>fab fa-bitcoin</v-icon>&nbsp; Inne
                sposoby</a>
            </v-btn>
          </v-col> -->
          <v-col cols="12">
            <v-progress-linear rounded v-model="timePercentElapsed" color="blue-grey" height="25">
              <template v-slot:default>
                <strong>{{
                  new Date(secondsLeft * 1000).toISOString().substring(14, 19)
                }}</strong>
              </template>
            </v-progress-linear>
          </v-col>

          <v-col cols="12" class="d-flex justify-center" ref="qr">
            <qrcode-vue :value="paymentData.address" :size="200" class="pa-1"
              :style="'background-color: white;'"></qrcode-vue>
          </v-col>
          <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0">
            Ten kod QR możesz zeskanować w bitomacie
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-text-field label="Adres Ethereum do wpłaty" v-model="paymentData.address" outlined readonly>
              <template v-slot:append>
                <v-btn :style="'transform: translateY(-4px);'" ref="copyAddress"
                  @click="copyToClipboard(paymentData.address)">
                  <v-icon>fas fa-copy</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-text-field label="Ilość Ethereum do wpłaty" v-model="paymentData.btcTotal" outlined readonly>
              <template v-slot:append>
                <v-btn :style="'transform: translateY(-4px);'" ref="copyTotal"
                  @click="copyToClipboard(paymentData.btcTotal)">
                  <v-icon>fas fa-copy</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" class="d-flex justify-center">
            <v-text-field :label="`Ilość ${$store.state.currency}`" v-model="paymentData.plnTotal" outlined readonly>
              <template v-slot:append>
                <v-btn :style="'transform: translateY(-4px);'" ref="copyTotal"
                  @click="copyToClipboard(paymentData.plnTotal)">
                  <v-icon>fas fa-copy</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row v-else-if="paymentActive && paymentValid && paymentMethod == 'psc'">
          <v-container fluid>
            <v-row>
              <v-col cols="12" class="d-flex justify-center align-center">
                <span class="text-h6" :style="'color: cyan;'">Oczekiwanie na płatność</span>
                &nbsp;
                <v-img src="../assets/nav1.png" :class="'rotate'"
                  :style="'max-height: 50px; max-width: 50px; width: 100%; height: 100%; cursor: pointer;'">
                </v-img>
              </v-col>
            </v-row>

            <v-row class="mt-0">
              <v-col cols="12">
                <v-progress-linear rounded v-model="timePercentElapsed" color="blue-grey" height="25">
                  <template v-slot:default>
                    <strong>{{
                      new Date(secondsLeft * 1000)
                        .toISOString()
                        .substring(14, 19)
                    }}</strong>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-4"></v-divider>
            <v-row>
              <v-col cols="12" class="d-flex justify-center">
                <v-img src="../assets/psc_horizontal.png" :style="'max-width: 250px; width:100%; height: auto;'">
                </v-img>
              </v-col>
            </v-row>

            <v-row class="d-flex justify-center ml-1 mr-1">
              <v-col cols="12" lg="8" md="8">
                <v-progress-linear rounded :style="'background-color: rgb(47, 47, 47)  !important;'"
                  v-model="getPscCodesTotalPercentage" color="#008aca" height="25">
                  <template v-slot:default>
                    <strong>
                      {{ getPscCodesTotal }}/{{ paymentData.plnTotal }} PLN
                    </strong>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>

            <v-row class="d-flex justify-center ml-1 mr-1">
              <v-col cols="12" lg="8" md="8">
                <v-simple-table light elevation="50">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left text--black">
                          <h3>PIN</h3>
                        </th>
                        <th class="text-left">
                          <h3>Kwota</h3>
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="pscCodes.length == 0">
                        <td>
                          <h5>Podaj kod(y) PIN z paragonu</h5>
                        </td>
                        <td>
                          <h5></h5>
                        </td>
                        <td>
                          <h5></h5>
                        </td>
                      </tr>
                      <tr v-else v-for="item in pscCodes" :key="item.code">
                        <td>
                          <h5>{{ formatPscCode(item.code) }}</h5>
                        </td>
                        <td>
                          <h5>{{ item.amount }} PLN</h5>
                        </td>
                        <td class="pl-0 pr-0"><v-btn icon @click="deletePscCode(item.code)"><v-icon>fas
                              fa-trash-alt</v-icon></v-btn></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center ml-1 mr-1 mt-0">
              <v-col cols="12" lg="4" md="4" class="mt-0 pb-0">
                <v-text-field label="Podaj PIN" placeholder="0000-0000-0000-0000" outlined dense filled v-model="pscInput"
                  @input="formatPscInput"></v-text-field>
              </v-col>
              <v-col cols="12" lg="4" md="4" class="mt-0 pb-0">
                <v-select :items="availablePscAmounts" v-model="selectedPscAmount" label="Wybierz nominał" outlined filled
                  dense></v-select>
              </v-col>
              <v-col cols="12" class="d-flex justify-center mt-0 pt-0">
                <v-btn light @click="addPscCode">
                  <v-icon>fas fa-plus-circle</v-icon>&nbsp;Dodaj pin
                </v-btn>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-4"></v-divider>
            <v-row class="d-flex justify-center mb-5">
              <v-col cols="12" lg="8" md="8">
                <v-btn class="mt-2" light block :disabled="getPscCodesTotalPercentage < 98" :loading="orderLoading"
                  @click="submitPscData"><v-icon :style="'color: green;'">fas
                    fa-check-circle</v-icon>&nbsp;Zapłacono</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row
          v-else-if="!paymentActive && paymentValid && paymentStatus == 'success' && (paymentMethod == 'btc' || paymentMethod == 'eth')">
          <v-col cols="12" class="d-flex justify-center align-center">
            <v-icon :style="'color: green; font-size: 80px;'">
              fas fa-check-circle
            </v-icon>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center text-center">
            <span class="text-h5">Płatność przyjęta!</span>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center text-center">
            <span>Teraz pozostało Ci już tylko czekać na przesyłkę &#128515;<br />
              Zamówienie zostało przekazane do realizacji! &#128674;</span>
          </v-col>
        </v-row>
        <v-row v-else-if="!paymentActive && paymentValid && paymentStatus == 'success' && paymentMethod == 'psc'">
          <v-col cols="12" class="d-flex justify-center align-center">
            <v-icon :style="'color: green; font-size: 80px;'">
              fas fa-check-circle
            </v-icon>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center text-center">
            <span class="text-h5">Płatność przyjęta!</span>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center text-center">
            <span><span :style="'color: orange;'"> Zweryfikujemy twoją płatność Paysafecard w ciągu 12h
                &#128515;</span><br />
              Po weryfikacji twoje zamówienie zostanie przekazane do realizacji! &#128674;</span>
          </v-col>
        </v-row>
        <v-row v-else-if="!paymentActive && paymentValid && paymentStatus == 'success' && paymentMethod == 'transfer'">
          <v-col cols="12" class="d-flex justify-center align-center">
            <v-icon :style="'color: green; font-size: 80px;'">
              fas fa-check-circle
            </v-icon>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center text-center">
            <span class="text-h5">Zamówienie przyjęte!</span>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center text-center">
            <span class="text-h6">Jeżeli chcesz opłacić swoje zamówienie przelewem/BLIK, napisz do wiadomość prywatną na
              telegramie i podaj swój NUMER ZAMÓWIENIA!</span>
          </v-col>
          <v-row class="d-flex justify-center mb-5">
            <v-col cols="12" class="d-flex justify-center">
              <v-btn large :color="'#0088cc'" class="no-uppercase" small>
                <a :href="$store.state.telegramContact" target="_blank"><span :style="'color: white; font-size: 11px'">
                    <v-icon>fas
                      fa-paper-plane</v-icon>&nbsp;Napisz wiadomość Telegram</span></a>
              </v-btn>
            </v-col>
          </v-row>
          <!-- <v-col cols="12" class="d-flex justify-center align-center text-center">
            <span><span :style="'color: orange;'"> Zweryfikujemy twoją płatność Paysafecard w ciągu 12h
                &#128515;</span><br />
              Po weryfikacji twoje zamówienie zostanie przekazane do realizacji! &#128674;</span>
          </v-col> -->
        </v-row>
        <v-row v-else-if="!paymentActive && paymentValid && paymentStatus == 'expired'
          ">
          <v-col cols="12" class="d-flex justify-center align-center">
            <v-icon :style="'color: red; font-size: 80px;'">
              fas fa-clock
            </v-icon>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center">
            <span class="text-h5">Płatność wygasła!</span>
          </v-col>
        </v-row>
        <v-row v-else-if="!paymentActive && paymentValid">
          <v-col cols="12" class="d-flex justify-center align-center text-center">
            <v-icon :style="'color: red; font-size: 80px;'">
              fas fa-times-circle
            </v-icon>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center">
            <span class="text-h5">Płatność nieudana!</span>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid v-if="!paymentLoading && !paymentValid">
        <v-row>
          <v-col cols="12" class="d-flex justify-center align-center">
            <v-icon :style="'color: red; font-size: 80px;'">
              fas fa-times-circle
            </v-icon>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center text-center">
            <span class="text-h6">Nie udało się znaleźć tej płatności!</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog v-model="tutorialDialog" :fullscreen="$vuetify.breakpoint.mobile" hide-overlay dark width="800" :transition="this.$vuetify.breakpoint.mobile
      ? 'slide-x-transition'
      : 'dialog-bottom-transition'
      ">
      <v-card>
        <v-toolbar>
          <v-btn icon @click="!(tutorialDialog = false) && ($refs.video.pause())">
            <v-icon :style="'color: white;'">{{
              this.$vuetify.breakpoint.mobile
              ? "fas fa-chevron-left"
              : "fas fa-times"
            }}</v-icon>
          </v-btn>
          <v-toolbar-title :style="'color: white;'">Jak zapłacić?
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container fluid class="p-1">
          <v-row class="d-flex justify-center">
            <v-col cols="12" class="d-flex justify-center">
              <div class="video-player">
                <video class="video" ref="video" :style="'width:100%; height:auto;'" controls>
                  <source src="../assets/tutorial_payment.mp4" type="video/mp4" />
                </video>
              </div>
            </v-col>
            <v-col cols="12" class="mt-3">
              <v-row>
                <v-col cols="12" class="d-flex justify-center text-center pt-0 pb-0 mt-2 mb-2">
                  <v-btn large light>
                    <a href="https://cryps.pl/kup-bitcoin-kantor-btc-pln/#ari-widget" target="_blank"
                      :style="'color: #1481D1 !important;'"><strong>Do strony cryps.pl</strong>&nbsp;<v-icon>fas
                        fa-arrow-circle-right</v-icon></a>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
  name: "OrderOverviewView",
  data: () => ({
    tutorialDialog: false,
    paymentLoading: true,
    orderLoading: false,
    ccLoading: false,
    exchangeUrl: "",
    paymentActive: false,
    paymentValid: false,
    paymentMethod: "btc",
    paymentStatus: "",
    paymentData: {},
    pscCodes: [

    ],
    availablePscAmounts: [
      {
        text: "20 PLN",
        value: 20,
      },
      {
        text: "30 PLN",
        value: 30,
      },
      {
        text: "50 PLN",
        value: 50,
      },
      {
        text: "100 PLN",
        value: 100,
      },
      {
        text: "200 PLN",
        value: 200,
      },
    ],
    pscInput: '',
    selectedPscAmount: 20,
    loopActive: true,
    loop: false,
    secondsLoop: false,
    secondsLeft: 0,
    timePercentElapsed: 0,
  }),
  computed: {
    // a computed getter
    getPscCodesTotal() {
      let total = 0;
      for (let i = 0; i < this.pscCodes.length; i++) {
        total += this.pscCodes[i].amount;
      }
      return total;
    },
    getPscCodesTotalPercentage() {
      let total = 0;
      for (let i = 0; i < this.pscCodes.length; i++) {
        total += this.pscCodes[i].amount;
      }
      let percentage = parseInt((total / this.paymentData.plnTotal) * 100);
      return percentage;
    },
  },
  components: {
    QrcodeVue,
  },
  created: function () {
    var self = this;
    self.getPaymentStatus();

    self.secondsLoop = self.loop = setInterval(() => {
      self.secondsLeft = self.secondsLeft - 1;
      self.timePercentElapsed = Math.min(
        100 - parseInt((self.secondsLeft / 3600) * 100),
        100
      );
    }, 1000);

    self.loop = setInterval(() => {
      if (!self.loopActive) {
        clearInterval(self.loop);
        return;
      }
      self.getPaymentStatus();
    }, 10000);
  },
  beforeDestroy() {
    try {
      clearInterval(this.secondsLoop);
      clearInterval(this.loop);
    } catch (error) {
      return;
    }
  },
  methods: {
    formatPscCode: function (code) {
      let F = "";
      for (let i = 0; i < code.length; i++) {
        if (i % 4 == 0 && i != 0) {
          F += " - ";
        }
        F += code[i];
      }
      return F;
    },
    formatPscInput: function () {
      let F = "";
      let val = this.pscInput.replaceAll(' ', '').replaceAll('-', '').slice(0, 16);
      for (let i = 0; i < val.length; i++) {
        if (i % 4 == 0 && i != 0) {
          F += " - ";
        }
        F += val[i];

      }
      var self = this;
      setTimeout(function () {
        self.pscInput = F.slice(0, 25);
      }, 10)

    },
    addPscCode: function () {
      let val = this.pscInput.replaceAll(' ', '').replaceAll('-', '').slice(0, 16).trim();
      if (isNaN(val)) {
        this.$toast.open({
          message: `<span class="font-weight-bold">Niepoprawny PIN!</span>`,
          type: "error",
          duration: 3000,
          position: "bottom",
        });
        return;
      }
      if (val.length != 16) {
        this.$toast.open({
          message: `<span class="font-weight-bold">Niepoprawny PIN!</span>`,
          type: "error",
          duration: 3000,
          position: "bottom",
        });
        return;
      }

      if (this.pscCodes.find(c => c.code == val) != undefined) {
        this.$toast.open({
          message: `<span class="font-weight-bold">Ten kod już jest wpisany!</span>`,
          type: "error",
          duration: 3000,
          position: "bottom",
        });
        return;
      }

      this.pscCodes = this.pscCodes.concat({
        code: val,
        amount: this.selectedPscAmount
      });
      this.pscInput = '';
    },
    deletePscCode: function (code) {
      this.pscCodes = this.pscCodes.filter(c => c.code != code);
    },
    copyToClipboard: async function (text) {
      try {
        await navigator.clipboard.writeText(text);
        this.$toast.open({
          message: `<span class="font-weight-bold">Skopiowano!</span>`,
          type: "info",
          duration: 3000,
          position: "bottom",
        });
      } catch (error) {
        console.log(error);
      }
    },
    submitPscData: function () {
      this.orderLoading = true;
      let codes = this.pscCodes;
      var self = this;
      this.$axios
        .post("/api/order/submit-psc", {
          orderNumber: this.$route.params.orderNumber,
          codes: codes
        })
        .then(async (response) => {
          if (response.data.success) {
            this.orderLoading = false;
            self.getPaymentStatus();
          } else {
            this.$toast.open({
              message: `<span class="font-weight-bold">${response.data.errorText}!</span>`,
              type: "error",
              duration: 3000,
              position: "bottom",
            });
            this.orderLoading = false;
          }
        })
        .catch((error) => {
          this.$toast.open({
            message: `<span class="font-weight-bold">Błąd podczas potwierdzania zamówienia!</span>`,
            type: "error",
            duration: 3000,
            position: "bottom",
          });
          this.orderLoading = false;
          console.log(error);
        });
    },
    getPaymentStatus: function () {
      this.$axios
        .post("/api/order/paymentstatus", {
          orderNumber: this.$route.params.orderNumber,
        })
        .then(async (response) => {
          if (response.data.success) {
            this.paymentValid = true;
            this.paymentLoading = false;
            this.paymentActive = response.data.paymentData.active;
            this.paymentMethod = response.data.paymentData.paymentMethod;
            if (!this.paymentActive) {
              this.paymentStatus = response.data.paymentData.status;
              this.loopActive = false;
            } else {
              this.secondsLeft = response.data.paymentData.secondsLeft;
              this.timePercentElapsed = Math.min(
                100 - parseInt((this.secondsLeft / 3600) * 100),
                100
              );
            }
            this.paymentData = response.data.paymentData;
          } else {
            this.paymentValid = false;
            this.$toast.open({
              message: `<span class="font-weight-bold">Błąd podczas pobierania danych płatności!</span>`,
              type: "error",
              duration: 3000,
              position: "bottom",
            });
            this.paymentLoading = false;
          }
        })
        .catch((error) => {
          this.paymentValid = false;
          this.$toast.open({
            message: `<span class="font-weight-bold">Błąd podczas pobierania danych płatności!</span>`,
            type: "error",
            duration: 3000,
            position: "bottom",
          });
          this.paymentLoading = false;
          console.log(error);
        });
    },

    goToCC: function () {
      this.ccLoading = true;
      this.$axios
        .post("/api/order/init-cc", {
          orderNumber: this.$route.params.orderNumber,
        })
        .then(async (response) => {
          if (response.data.success) {
            this.ccLoading = false;
            this.exchangeUrl = response.data.exchangeUrl;
          } else {
            this.$toast.open({
              message: `<span class="font-weight-bold">Błąd podczas wczytywania płatności!</span>`,
              type: "error",
              duration: 3000,
              position: "bottom",
            });
            this.ccLoading = false;
            this.exchangeUrl = "";
          }
        })
        .catch((error) => {
          this.ccLoading = false;
          this.$toast.open({
            message: `<span class="font-weight-bold">Błąd podczas wczytywania płatności!</span>`,
            type: "error",
            duration: 3000,
            position: "bottom",
          });
          console.log(error);
          this.exchangeUrl = "";
        });
    },
  },
};
</script>

<style>
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  width: 100%;
}

.video-container video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

#player-overlay {
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  z-index: 999;
}

.rotate {
  animation: rotation 2s infinite linear;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}
</style>
